import type { TextareaHTMLAttributes, RefObject } from "react";

import styled from "styled-components";

import { colorsPalettes, setElevation, setFontVariant } from "@similarweb/styles";

const TextAreaInput = styled.textarea<{ hasError?: boolean }>`
    && {
        ${setFontVariant("input2", colorsPalettes.carbon[400])}
        padding: 16px;
        border-radius: 3px;
        border: 1px solid ${colorsPalettes.midnight[50]};
        resize: vertical;
        transition:
            box-shadow 0.3s ease-in-out,
            border-color 0.3s ease-in-out;

        &:focus {
            ${setElevation("Z1")}
            border-color: ${colorsPalettes.blue[400]};
            outline: none;
        }

        &:disabled,
        &[readonly] {
            background-color: ${colorsPalettes.bluegrey[200]};
            color: ${colorsPalettes.midnight[100]};
            cursor: not-allowed;
            box-shadow: none;
        }

        ::placeholder {
            color: ${colorsPalettes.carbon["200"]};
        }

        /* stylelint-disable-next-line selector-not-notation */
        &[aria-invalid="true"]:not(:disabled):not([readonly]) {
            border-color: ${colorsPalettes.red["400_P"]};
        }
    }
`;

interface ITextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
    ref?: RefObject<HTMLTextAreaElement>;
    hasError?: boolean;
}

export const TextArea = ({ hasError, ...rest }: ITextAreaProps) => {
    return (
        <TextAreaInput
            aria-invalid={hasError}
            {...rest}
        />
    );
};
